import { ChangePasswordForm } from 'features/auth/change-password';
import { useTitle } from '../helpers';

/**
 * @page ChangePass page
 */
const ChangePass = () => {
  useTitle('Смена пароля');

  return <ChangePasswordForm />;
};

export default ChangePass;
